import {
  refreshByCodeRequest,
  refreshRequest,
} from "src/engine/repositories/accountsToken"
import {
  selectToken,
  refreshToken as selectRefreshToken,
} from "src/engine/modules/session/selectors"
import { setTokens } from "src/engine/modules/session/actions/creators"
import { getStore } from "src/engine/plugins/BridgeStore"
import getCurrentUrl from "src/engine/modules/session/helpers/getCurrentUrl"
import redirectToLoginPage from "src/engine/modules/session/helpers/redirectToLoginPage"
import { clearSession } from "../session/actions/creators"

let refreshPromise = null

export const redirectUrl =
  localStorage.getItem(`redirectUrl`) || getCurrentUrl()

const putTokenToStore = (tokenType, token, refreshToken, expiresIn) =>
  getStore().dispatch(setTokens(tokenType, token, refreshToken, expiresIn))

export const getToken = () =>
  !refreshPromise
    ? Promise.resolve(selectToken(getStore().getState()))
    : refreshPromise

export const refreshTokenByCode = code => {
  if (!refreshPromise) {
    refreshPromise = refreshByCodeRequest(code, redirectUrl)
      .then(response => {
        const { data } = response
        putTokenToStore(
          data.token_type,
          data.access_token,
          data.refresh_token,
          data.expires_in,
        )
        refreshPromise = null
      })
      .catch(() => {
        /* Something went wrong, go to login page again */
        redirectToLoginPage()
      })
  }
  return refreshPromise
}
export const refreshToken = () => {
  if (!refreshPromise) {
    refreshPromise = refreshRequest(selectRefreshToken(getStore().getState()))
      .then(response => {
        const { data } = response
        putTokenToStore(
          data.token_type,
          data.access_token,
          data.refresh_token,
          data.expires_in,
        )
        refreshPromise = null
      })
      .catch(() => {
        /* Something went wrong, go to login page again */
        getStore().dispatch(clearSession())
        redirectToLoginPage()
      })
  }
  return refreshPromise
}
